<template>
    <div id="wrapper" class="wrapper d-flex flex-column align-items-stretch">
        <nav-bar />
        <div class="d-flex" style="height: calc(100vh - 65px);">
            <side-bar />
            <div class="d-flex flex-column position-relative w-100" :class="{ 'mt-5': banners.length }">
                <div class="banner-text" v-if="banner_hiding == true && banners.length">
                    <template v-for="(banner, index) in banners">
                        <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();"
                            v-if="index == 0">
                            <a class="banner-link" :href="banner.cta_url" target="_blank">{{ $t(banner.content) }}</a>
                            <span class="banner-btn" v-html="$t('mkt_btn_guide')"></span>
                        </marquee>
                    </template>
                </div>
                <div class="event-image" v-if="banner_hiding == true && banners.length"></div>
                <router-view>
                </router-view>
                <footer-element />
            </div>
        </div>
        <div class="modal fade" id="selectLangModal" tabindex="-1" role="dialog" aria-labelledby="selectLangModal"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('choose_language') }}</h3>
                    <div class="select-lang">

                        <div :class="locate == localize.lang ? 'select-lang-item active' : 'select-lang-item'"
                            @click="setLocate(localize)" v-for="(localize, index) in localizes">
                            <div class="lang-icon">
                                <img :src="localize.img_flag" alt="">
                            </div>
                            <div class="lang-text">
                                {{ $t(localize.lang) }}
                            </div>
                            <div class="lang-checked" v-if="locate == localize.lang">
                                <i class="ito-icon-checked-white"></i>
                            </div>
                        </div>

                    </div>
                    <div class="ito-btn-large mt-20" @click="updateLocate()"
                        style="width: auto; padding: 9px 40px; margin: 8px auto 0 auto;line-height: inherit;">
                        {{ $t('confirm') }}
                    </div>
                </div>
            </div>
        </div>

        <div class="loading" id="loading" v-if="isLoading">
            <img class="spinner" src="/themes/ito/images/loadding.png" alt="" />
        </div>

        <upgrade-account-modal />

        <div class="modal fade" id="updateGradeModal" tabindex="-1" role="dialog" aria-labelledby="updateGradeModal"
            aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">
                <div class="modal-content box-shadow-main" style="padding-top: 65px;">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <div class="img-title">
                        <img src="/themes/ito/images/image01/grade.png" alt="">
                    </div>
                    <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
                    <br />
                    <!--<h3 class="popup-description mb-20">{{$t('choose_grade_2')}}</h3>-->

                    <div class="grade-select-body">
                        <div class="grade-select-list">
                            <div @click="selectGrade(1)"
                                :class="checkGradeSelected(1) ? ['grade-select-item', 'active'] : ['grade-select-item']">1
                            </div>
                            <div @click="selectGrade(2)"
                                :class="checkGradeSelected(2) ? ['grade-select-item', 'active'] : ['grade-select-item']">2
                            </div>
                            <div @click="selectGrade(3)"
                                :class="checkGradeSelected(3) ? ['grade-select-item', 'active'] : ['grade-select-item']">3
                            </div>
                            <div @click="selectGrade(4)"
                                :class="checkGradeSelected(4) ? ['grade-select-item', 'active'] : ['grade-select-item']">4
                            </div>
                            <div @click="selectGrade(5)"
                                :class="checkGradeSelected(5) ? ['grade-select-item', 'active'] : ['grade-select-item']">5
                            </div>
                        </div>
                    </div>
                    <div class="txt-error" v-if="sl_grade_err" style="font-size: 14px; margin: 5px 0px; color: #FA450F;">
                        {{ sl_grade_err }}</div>
                    <div class="text-center">
                        <!--<button class="ito-btn-large btn-test mt-20" style="width: 115px;" @click="confirmSelectGrade">-->
                        <button class="ito-btn-large btn-test mt-20" style="width: 115px;" @click="changeGrade">
                            {{ $t('confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="placementModal" tabindex="-1" role="dialog" aria-labelledby="placementModal"
            aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">
                <div class="modal-content box-shadow-main" style="padding-top: 65px;">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <div class="img-title">
                        <img src="/themes/ito/images/image01/grade.png" alt="">
                    </div>
                    <h3 class="popup-title-verify">{{ $t('choose_grade_3') }}</h3>
                    <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
                    <br />

                    <div class="grade-select-body">
                        <div class="grade-select-list">
                            <div @click="selectGrade(1)"
                                :class="checkGradeSelected(1) ? ['grade-select-item', 'active'] : ['grade-select-item']">1
                            </div>
                            <div @click="selectGrade(2)"
                                :class="checkGradeSelected(2) ? ['grade-select-item', 'active'] : ['grade-select-item']">2
                            </div>
                            <div @click="selectGrade(3)"
                                :class="checkGradeSelected(3) ? ['grade-select-item', 'active'] : ['grade-select-item']">3
                            </div>
                            <div @click="selectGrade(4)"
                                :class="checkGradeSelected(4) ? ['grade-select-item', 'active'] : ['grade-select-item']">4
                            </div>
                            <div @click="selectGrade(5)"
                                :class="checkGradeSelected(5) ? ['grade-select-item', 'active'] : ['grade-select-item']">5
                            </div>
                        </div>
                    </div>

                    <div class="text-center">
                        <button class="ito-btn-large btn-test mt-20" style="width: 150px;" @click="confirmPlacementTest">
                            {{ $t('do_placement') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="testPlacementModal" tabindex="-1" role="dialog" aria-labelledby="testPlacementModal"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 650px;">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('placement_test') }}</h3>
                    <div class="d-flex quick-test-box text-center">
                        <img src="/themes/ito/images/reading.svg" style="width: 150px; margin: 0 auto;">
                    </div>
                    <div class="quick-test-bottom box-shadow-main d-flex mt-20">
                        <div class="quick-test-bottom-text">
                            <div class="txt-2-rows">
                                <div class="text-right d-inline-block left-title">{{ $t('total') }}:</div>
                                <div class="d-inline-block right-text">{{ placement_test.total_question }}
                                    {{ $t('scores') }}
                                </div>
                            </div>
                            <div class="txt-2-rows">
                                <div class="text-right d-inline-block left-title">{{ $t('time_allowance') }}:</div>
                                <div class="d-inline-block right-text">{{ placement_test.time }} {{ $t('minutes') }}</div>
                            </div>
                        </div>
                        <div class="ito-btn-large btn-test mt-20" @click="placementTest">
                            {{ $t('start') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <daily-bonus-modal v-if="user_info.first_login == 1" :user="user_info" @updateFirstLogin="updateFirstLogin" />
        <get-reward-modal :reward="reward"></get-reward-modal>
        <err-modal :err_code="err_message"></err-modal>
        <logout-modal></logout-modal>
        <event-modal :banners="banners" @hideBanner="hideBanner()"></event-modal>

        <!--<audio ref="audio" src="/themes/ito/audios/musicBG-app.mp3" ></audio>-->
    </div>
</template>

<script>
import axios from "axios";
import SideBar from "../SideBar";
import NavBar from "../NavBar";
import FooterElement from "../FooterElement";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
import { getPlacementTest, startPlacementTest } from "../../models/placement_test";
import UpgradeAccountModal from "../modal/UpgradeAccountModal";
import { updateLanguage, changeGrade } from '../../models/profile';
import { getBanners } from '../../models/dashboard';
import router from "../../router";

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import DailyBonusModal from '../modal/DailyBonusModal.vue';
import GetRewardModal from '../modal/GetRewardModal.vue';
import ErrModal from '../modal/ValidateModal.vue';
import LogoutModal from '../modal/LogoutModal.vue';
import EventModal from '../modal/EventModal.vue';


export default {
    name: "AppLayoutEvent",

    data() {
        const grade_default = localStorage.getItem('grade');
        const configs = getConfigs();
        const localizes = configs.localize || [];
        const banner_hiding = localStorage.getItem('banner_hidden');

        return {
            locate: getLanguage(),
            locate_obj: null,
            user: {
                grade: 1
            },
            grade_selected: grade_default || 1,
            placement_test: {
                id: 0,
                condition_pass: 0,
                time: 0,
                total_question: 0,
            },
            configs: configs,
            localizes: localizes,
            sl_grade_err: '',
            err_message: '',
            reward: '',
            banners: [],
            banner_hiding: JSON.parse(banner_hiding),
        };
    },

    components: {
        UpgradeAccountModal,
        FooterElement,
        NavBar,
        SideBar,
        DailyBonusModal,
        GetRewardModal,
        ErrModal,
        LogoutModal,
        EventModal
    },

    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        user_info() {
            return this.$store.state.user_info;
            ;
        },

    },

    updated() {
        this.$nextTick(() => {
            $('#eventModal').on('hidden.bs.modal', function (e) {
                $("#dailyBonusModal").modal('show');
                localStorage.setItem("banner_hidden", true);
            })
        })


    },

    async mounted() {
        //setInterval(this.refreshData, 2000);
        // this.grade_selected = this.user_info.grade;
        this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
        this.fetch();

        const firebaseSupported = await isSupported()
        if (!firebaseSupported || !('Notification' in window)) return;

        // init push noti
        const firebaseConfig = {
            apiKey: "AIzaSyDMaQnL8UUvi1O-CHCgDch22U47y_K-wIQ",
            authDomain: "ismart-pro-5357f.firebaseapp.com",
            projectId: "ismart-pro-5357f",
            storageBucket: "ismart-pro-5357f.appspot.com",
            messagingSenderId: "580103667062",
            appId: "1:580103667062:web:a59380dac56ef9a4f58e57",
            measurementId: "G-JD84SKYWPT"
        };

        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                getToken(messaging, { vapidKey: 'BGQxkHZzcAhSiVVmIHo1FE5FVqzaVKVOw2hBDu03emmXPIiO5Fg-8V-Xulu6v-SS045k3ZSNEWbnYNyK_s9763k' }).then((currentToken) => {
                    if (currentToken) {
                        window.localStorage.setItem('firebaseToken', currentToken);
                    } else {
                        console.log('No registration token available. Request permission to generate one.');
                    }
                }).catch((err) => {
                    console.log('An error occurred while retrieving token. ', err);
                });
            } else {
                console.log('Unable to get permission to notify.');
            }
        });
    },

    methods: {

        fetch() {
            this.getBanners()

            this.handleGACustomEvent();
        },

        refreshData() {
            if (this.$refs.audio) {
                this.$refs.audio.play();

                document.getElementById('footer').click();
            }
        },

        updateFirstLogin(status, reward) {
            if (status == 0) {
                this.user_info.first_login = status;
                this.reward = reward;
                $('#getRewardedModal').modal('show');
            }
            else {
                this.err_message = reward
                $('#getValidateModal').modal('show');
            }
        },

        getSoundClick() {
            soundClick();
        },

        // confirmSelectGrade() {
        //     const that = this;

        //     that.getSoundClick();
        //     // console.log(this.user_info.placement_test);
        //     // if (this.user_info.student_type != 1 && this.user_info.placement_test == 0) {
        //     //     localStorage.setItem('grade', this.grade_selected);
        //     //     $('#updateGradeModal').modal("hide");
        //     //     window.location.href = '/'
        //     // } else
        //     if (this.user_info.student_type == 1) {
        //         if (this.user_info.grade + 1 == this.grade_selected) {
        //             var msg = this.$i18n.t('change_grade_error_1')
        //             this.sl_grade_err = msg
        //             return false;
        //         }
        //         if (this.user_info.grade + 1 < this.grade_selected) {
        //             this.sl_grade_err = 'You can not study grade ' + this.grade_selected;
        //             return false;
        //         }
        //         localStorage.setItem('grade', this.grade_selected);
        //         $('#updateGradeModal').modal("hide");
        //         window.location.href = '/'
        //     } else {
        //         if (this.user_info.grade >= this.grade_selected) {
        //             localStorage.setItem('grade', this.grade_selected);
        //             // that.$store.commit("setLoading", this.grade_selected);
        //             $('#updateGradeModal').modal("hide");
        //             // location.reload();
        //             window.location.href = '/'
        //         } else {
        //             if (this.user_info.placement_test == 0) {
        //                 if (this.user_info.grade + 1 == this.grade_selected) {
        //                     // this.sl_grade_err = 'You need to pass the final test of grade '+this.user_info.grade;
        //                     this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');
        //                     return false;
        //                 }
        //                 if (this.user_info.grade + 1 < this.grade_selected) {
        //                     // this.sl_grade_err = 'You can not study grade '+this.grade_selected;
        //                     this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');
        //                     return false;
        //                 }
        //             }
        //             else {
        //                 that.$store.commit("setLoading", true);
        //                 // :to="{path: '/lesson/'+subject_id+'-'+units.id+'-'+lesson.id}"
        //                 const path = '/placement-test/' + that.grade_selected
        //                 if (this.$route.path !== path) {
        //                     this.$router.push(path)
        //                 } else {
        //                     that.$store.commit("setLoading", false);
        //                     $('#updateGradeModal').modal("hide");
        //                 }
        //             }
        //         }
        //     }
        // },

        confirmPlacementTest() {
            const that = this;

            that.getSoundClick();

            // if (this.user_info.grade >= this.grade_selected) {
            //     localStorage.setItem('grade', this.grade_selected);
            //     $('#placementModal').modal("hide");
            //     window.location.href = '/'
            // } else {
            that.$store.commit("setLoading", true);
            const path = '/placement-test/' + that.grade_selected
            if (this.$route.path !== path) {
                this.$router.push(path)
                $('#placementModal').modal("hide");
            } else {
                that.$store.commit("setLoading", false);
                $('#placementModal').modal("hide");
            }
            // }
        },

        placementTest() {
            const that = this;

            that.getSoundClick();

            that.$store.commit("setLoading", true);

            startPlacementTest({
                id: this.placement_test.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#testPlacementModal').modal("hide");
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        selectGrade(grade) {
            this.grade_selected = grade;
        },

        checkGradeSelected(grade) {
            return this.grade_selected == grade;
        },

        setLocate(e) {
            this.getSoundClick();

            this.locate_obj = e;
            this.locate = e.lang;

            //localStorage.setItem('lang', e);
        },

        updateLocate() {
            const that = this;

            this.getSoundClick();

            localStorage.setItem('lang', this.locate);

            if (that.locate_obj != null) {
                that.$store.commit("setLoading", true);

                updateLanguage({
                    id: that.locate_obj.id,
                    is_raw: true
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        return;
                    }
                    location.reload();
                }).catch(({ response }) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            }

        },
        // = 0 -> có thể change grade
        // = 1 -> cần hoàn thành các bài học
        // = 2 -> cần làm placement test
        // = 3 -> cần làm final test
        // = 4 -> chưa đủ điều kiện để học lớp này"
        changeGrade() {
            const that = this;
            that.$store.commit("setLoading", true);
            const params = {
                'grade': that.grade_selected
            }
            changeGrade(
                params
            ).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    return;
                }
                switch (parseInt(response.data.results.status)) {
                    case 0:
                        localStorage.setItem('grade', that.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        window.location.href = '/';
                        break;
                    case 1:
                        // this.sl_grade_err = 'You need to pass the final test of grade '+that.user_info.grade;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    case 2:
                        // that.$store.commit("setLoading", true);
                        // const path = '/placement-test/' + that.grade_selected;
                        // if (that.$route.path !== path) {
                        //     that.$router.push(path)
                        //     $('#updateGradeModal').modal("hide");
                        // } else {
                        //     that.$store.commit("setLoading", false);
                        //     $('#updateGradeModal').modal("hide");
                        // }
                        localStorage.setItem('grade', that.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        window.location.href = '/';
                        break;
                    case 3:
                        // this.sl_grade_err = 'You need to pass the final test of grade '+that.user_info.grade;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    case 4:
                        // this.sl_grade_err = 'You can not study grade '+that.grade_selected;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    default:
                        $('#updateGradeModal').modal("hide");
                        break;
                }
            });
        },
        getBanners() {
            let params = {}
            axios.all([getBanners(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 0) {
                        return;
                    }
                    var banner = [];
                    const banners = response.data.results || [];
                    banners.forEach((item) => {
                        if (item.category_id == 6) {
                            var image = this.getBannerImage(item.banner_url)
                            item.image = image
                            banner.push(item);
                        }
                    })
                    this.banners = banner;
                    const that = this;
                    let banner_hiding = that.banner_hiding
                    if (!banner_hiding) {
                        $('#eventModal').modal('show');
                    }
                    if (this.user_info.first_login == 1 && banner_hiding) {
                        $("#dailyBonusModal").modal('show');
                    }
                })
            );
        },
        getBannerImage(images) {
            images = JSON.parse(images);
            var lang = localStorage.getItem('lang');
            var imageStyleObject = {
                'content': 'url("' + images[lang] + '")',
            }
            return imageStyleObject
        },
        hideBanner() {
            this.banner_hiding = true;
        },
        handleGACustomEvent() {
            if (this.user_info.user_id) {
                var element = 'IP1_W_0000'
                var user_id = this.user_info.user_id || '';
                var school_id_ref = this.user_info.school_id_ref || '';
                var grade_id = this.user_info.grade_code || '';
                var class_id = this.user_info.class_code || '';
                var params = {
                    'w_user_id': user_id,
                    'school_id': school_id_ref,
                    'grade_id': grade_id,
                    'class_id': class_id
                };
                params[element] = user_id + ((user_id != '') ? '|' : '') + school_id_ref + '|' + grade_id + '|' + class_id;
                gtag('event', element, params);
            }

        },
    }
}
</script>
<style scoped>
.wrapper {
    background-image: var(--background-image-event);
}

.banner-text {
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 65px;
    z-index: 1;
    height: 47px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.7);
    animation-name: slidedown;
    animation-duration: 1s;
}

.banner-text .banner-link {
    color: #F04821;
    text-align: center;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-decoration-line: underline;
}

.banner-text span.banner-btn {
    display: inline-block;
    box-shadow: 0px 2px 0px 0px #ffffff33 inset;
    box-shadow: 4px 4px 0px 0px #0000000d;
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-align: center;
    color: #FFFFFF !important;
    padding: 8px 12px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 30px;
    margin-left: 10px;
}



@keyframes slidedown {
    from {
        top: 47px;
    }

    to {
        top: 65px;
    }
}

.event-image {
    position: fixed;
    bottom: 0;
    left: 100px;
    width: 150px;
    height: 213px;
    flex-shrink: 0;
    content: url('/public/themes/ito/images/background-login-chrismas-left.svg');
    z-index: 1;
    animation-name: slide-ltr;
    animation-duration: 1s;
    opacity: 1;
}

@keyframes slide-ltr {
    from {
        left: 50px;
        opacity: 0;
    }

    to {
        left: 100px;
        opacity: 1;
    }
}
</style>
